<app-spinner [isLoading]="isLoading" *ngIf="isLoading"></app-spinner>
<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <header class="header">
        <img
          class="header-logo"
          src="assets/images/logo/logo.svg"
          alt="" />
      </header>
      <div class="login-card">
        <div data-test="login-form" class="login-main">
          <form class="theme-form" [formGroup]="loginForm">
            <div class="form-group">
              <label class="col-form-label">{{'forms.username' | translate}}</label>
              <input
                data-test="email"
                class="form-control"
                type="email"
                placeholder="test@mail.com"
                formControlName="email"
              />
              @if (loginForm.controls['email'].touched &&
              loginForm.controls['email'].errors?.['required']) {
              <div class="text text-danger mt-1">{{'forms.error_email_required' | translate }}</div>
              } @if (loginForm.controls['email'].touched &&
              loginForm.controls['email'].errors?.['email']) {
              <div class="text text-danger mt-1">{{'forms.error_email_invalid' | translate }}</div>
              }
            </div>
            <div class="form-group">
              <label class="col-form-label">{{'forms.password' | translate}}</label>
              <div class="form-input position-relative">
                <input
                  data-test="password"
                  class="form-control"
                  type="password"
                  name="login[password]"
                  [type]="show ? 'text' : 'password'"
                  placeholder="*********"
                  formControlName="password"
                />
                <div class="show-hide">
                  <span (click)="show = !show" [class.show]="show">
                      <i class="fa fa-eye" *ngIf="!show"></i>
                      <i class="fa fa-eye-slash" *ngIf="show"></i>
                  </span>
                </div>
                @if (loginForm.controls['password'].touched &&
                loginForm.controls['password'].errors?.['required']) {
                <div class="text text-danger mt-1">{{'forms.error_password_required' | translate}}</div>
                }
              </div>
            </div>
            <div class="form-group">
              <div class="checkbox p-0">
                <input
                  data-test="remember-me"
                  id="rememberMe"
                  type="checkbox"
                  formControlName="rememberMe"
                />
                <label for="rememberMe"
                  >{{ 'login.remember_password' | translate }}</label
                >
              </div>
            </div>
            <div class="form-group">
              <a
                data-test="forgot-password"
                class="link"
                [routerLink]="['/auth/reset-password']"
                >{{ 'login.have_you_forgot_password' | translate }}</a
              >
            </div>
            <div class="form-group">
              <div class="text-left mt-3">
                <button
                  data-test="login-button"
                  class="btn btn-primary"
                  type="submit"
                  
                  (click)="login()"
                >
                  {{ 'button_labels.login' | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer footer-fix">
    <app-footer></app-footer>
  </footer>
</div>
